import { render, staticRenderFns } from "./LvTextCard.vue?vue&type=template&id=6c7582bd"
import script from "./LvTextCard.vue?vue&type=script&lang=js"
export * from "./LvTextCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports